import { Box, Grid2, IconButton, Tooltip, Typography } from "@mui/material";
import { CropSquare, Desk, Mouse } from "@mui/icons-material";
import { ToolSelection } from "../../Views/CreateFloorPlanView/CreateFloorPlanView";
import { useTranslation } from "react-i18next";

interface Props {
  selectedTool: ToolSelection;
  onSelectTool: (tool: ToolSelection) => void;
  setShowPlaceAdd: (p: boolean) => void;
  setIsMultiPlaces: (m: boolean) => void;
  setTypeOfPlaces: (t: number) => void;
  setNumberOfPlacesAdd: (a: number) => void;
  setShowZoneAdd: (z: boolean) => void;
  setTypeOfZone: (t: number) => void;
  isFloorPlanForService?: boolean;
}

export function SideToolbar({
  onSelectTool,
  selectedTool,
  setShowPlaceAdd,
  setIsMultiPlaces,
  setTypeOfPlaces,
  setNumberOfPlacesAdd,
  setShowZoneAdd,
  setTypeOfZone,
  isFloorPlanForService = false
}: Readonly<Props>) {
  const { t } = useTranslation();

  const resetPlaceState = () => {
    setShowPlaceAdd(false);
    setIsMultiPlaces(false);
    setTypeOfPlaces(1);
    setNumberOfPlacesAdd(0);
  };

  const resetZoneState = () => {
    setShowZoneAdd(false);
    setTypeOfZone(1);
  };
  const selectZoneCreate = () => {
    setShowZoneAdd(true);
    setTypeOfZone(1);
  };

  return (
    <Box
      sx={[
        theme => ({
          border: "1px solid #00000088",
          backgroundColor: "#ffffff",
          opacity: 0.95,
          position: "absolute",
          top: 65,
          m: 1,
          borderRadius: 2,
          ...theme.applyStyles("dark", {
            backgroundColor: "#000000"
          })
        }),
        isFloorPlanForService ? { display: "none" } : { display: "initial" }
      ]}
    >
      <Grid2 container sx={{ width: 100 }} data-testid="tool-container">
        {/** normal tool to select zones and desks */}
        <Grid2
          size={{ xs: 6 }}
          sx={[
            { borderRadius: 2 },
            selectedTool === undefined ? { backgroundColor: "blue" } : { backgroundColor: null }
          ]}
        >
          <Tooltip
            title={<Typography>{t("SelectSideToolbarLabel")}</Typography>}
            aria-label={"SelectSideToolbarLabel"}
          >
            <IconButton
              data-testid="tool-btn-selectDesk"
              onClick={() => {
                onSelectTool(undefined);
                resetPlaceState();
                resetZoneState();
              }}
              size={"large"}
            >
              <Mouse sx={[selectedTool === undefined ? { color: "white" } : { color: null }]} />
            </IconButton>
          </Tooltip>
        </Grid2>
        {/** tool to set new zone */}
        <Grid2
          size={{ xs: 6 }}
          sx={[
            { borderRadius: 2 },
            selectedTool === "ZONE.NEW" ? { backgroundColor: "blue" } : { backgroundColor: null }
          ]}
        >
          <Tooltip
            title={<Typography>{t("CreateZonesSideToolbarLabel")}</Typography>}
            aria-label={"CreateZonesSideToolbarLabel"}
          >
            <IconButton
              data-testid="tool-btn-createZone"
              onClick={() => {
                onSelectTool("ZONE.NEW");
                selectZoneCreate();
                resetPlaceState();
              }}
              size={"large"}
            >
              <CropSquare
                sx={[selectedTool === "ZONE.NEW" ? { color: "white" } : { color: null }]}
              />
            </IconButton>
          </Tooltip>
        </Grid2>
        {/** tool to set new desks */}
        <Grid2
          size={{ xs: 6 }}
          sx={[
            { borderRadius: 2 },
            selectedTool === "DESK.NEW" ? { backgroundColor: "blue" } : { backgroundColor: null }
          ]}
        >
          <Tooltip
            title={<Typography>{t("CreatePlacesSideToolbarLabel")}</Typography>}
            aria-label={"CreatePlacesSideToolbarLabel"}
          >
            <IconButton
              data-testid="tool-btn-createDesk"
              onClick={() => {
                onSelectTool("DESK.NEW");
                setShowPlaceAdd(true);
                setNumberOfPlacesAdd(1);
                resetZoneState();
              }}
              size={"large"}
            >
              <Desk sx={[selectedTool === "DESK.NEW" ? { color: "white" } : { color: null }]} />
            </IconButton>
          </Tooltip>
        </Grid2>
      </Grid2>
    </Box>
  );
}
